<template>
    <div v-cloak>
        <div class="address-list-container col-3">
            <div class="address-box clearfix">
                <el-checkbox-group v-model="selectRegionIds">
                    <ul class="address-list">
                        <li v-for="item in provinces" class="address-item">
                            <el-checkbox :label="item.id" @change="checkChange(item, 2);">&nbsp;</el-checkbox>
                            <span @click="regionChange(item, 2);" class="inline-block city-name">{{item.name}}</span>
                        </li>
                    </ul>
                </el-checkbox-group>
                <el-checkbox-group v-model="selectRegionIds">
                    <ul class="address-list">
                        <li v-for="item in citys" class="address-item">
                            <el-checkbox :label="item.id" v-if="selectRegionIds.indexOf(item.provinceId) < 0" :disabled="selectRegionIds.indexOf(item.provinceId) >= 0" @change="checkChange(item, 3);">
                                &nbsp;
                            </el-checkbox>
                            <span @click="regionChange(item, 3);" class="inline-block city-name">{{item.name}}</span>
                        </li>
                    </ul>
                </el-checkbox-group>
                <el-checkbox-group v-model="selectRegionIds">
                    <ul class="address-list">
                        <li v-for="item in countys" class="address-item">
                            <el-checkbox :label="item.id" v-if="selectRegionIds.indexOf(item.provinceId) < 0 && selectRegionIds.indexOf(item.cityId) < 0" :disabled="selectRegionIds.indexOf(item.cityId) >= 0 || selectRegionIds.indexOf(item.provinceId) >= 0" @change="checkChange(item, 4);">
                                &nbsp;
                            </el-checkbox>
                            <span @click="regionChange(item, 4);" class="inline-block city-name">{{item.name}}</span>
                        </li>
                    </ul>
                </el-checkbox-group>
            </div>
        </div>
        <div v-if="isShowDiv" class="simple-row">
            <span>当前选择：</span><span class="ml15" v-for="item in selectRegionList">{{item.regionName}}</span>
        </div>
    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Routes } from '../../app.vues'

    import comnApi from '../../api/comn'

    export default {
        name: 'swb-region-select',
        desc: '地区选择',
        props: {
            level: {
                type: Number,
                default: 3
            },
            regionList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            isShowDiv: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                provinces: [],
                citys: [],
                countys: [],
                selectRegionIds: [],
                selectRegionList: [],
                thisProvince: {},
                thisCity: {}
            }
        },
        created: function () {
            let self = this;
            //
            self.fetchData();
        },
        watch: {
            regionList: function (newValue, oldValue) {
                this.fetchData();
            }
        },
        methods: {
            fetchData: function () {
                let self = this;
                let selectRegionIds = [];
                let selectRegionList = [];
                //
                let regionList = self.regionList;
                if(regionList != null && regionList.length > 0) {
                    for(var i = 0; i < regionList.length; i++) {
                        let region = regionList[i];
                        //
                        let item = {};
                        item.regionId = region.regionId;
                        item.regionName = region.regionName;
                        item.provinceId = region.provinceId || null;
                        item.cityId = region.cityId || null;
                        item.countyId = region.countyId || null;
                        selectRegionList.push(item);
                        //
                        selectRegionIds.push(region.regionId);
                    }
                    //
                    self.selectRegionIds = selectRegionIds;
                    self.selectRegionList = selectRegionList;
                }
                self.getRegionsByParentId(1, -1);
            },
            checkChange: function (item, level) {
                let self = this;
                let selectRegionList = self.selectRegionList || [];
                //
                let selectRegionIds = Utils.merge([], self.selectRegionIds);
                if(selectRegionIds.indexOf(item.id) >= 0) {
                    //
                    for(var i = 0; i < selectRegionList.length; i++) {
                        let region = selectRegionList[i];
                        //
                        if(item.id == region.regionId) {
                            selectRegionList.splice(i, 1);
                            i--;
                            continue;
                        }
                        if(item.level == 1 || item.level == 2) {
                            if(item.id == region.provinceId || item.id == region.cityId) {
                                selectRegionList.splice(i, 1);
                                let deleteIndex = selectRegionIds.indexOf(region.regionId);
                                if(deleteIndex >= 0) {
                                    selectRegionIds.splice(deleteIndex, 1);
                                    i--;
                                    continue;
                                }
                            }
                        }
                    }
                    //
                    let checkitem = {};
                    checkitem.regionId = item.id;
                    checkitem.provinceId = item.provinceId || null;
                    checkitem.cityId = item.cityId || null;
                    checkitem.countyId = item.countyId || null;
                    let regionName = '';
                    //
                    if(item.level == 1) {
                        regionName = item.name;
                    } else if(item.level == 2) {
                        regionName = self.thisProvince.name + item.name
                    } else if(item.level == 3) {
                        regionName = self.thisProvince.name + self.thisCity.name + item.name;
                    }
                    //
                    checkitem.regionName = regionName;
                    selectRegionList.push(checkitem);
                } else {
                    for(var i = 0; i < selectRegionList.length; i++) {
                        let region = selectRegionList[i];
                        if(item.id == region.regionId) {
                            selectRegionList.splice(i, 1);
                        }
                    }
                }
                self.selectRegionIds = Utils.merge([], selectRegionIds);
                //
                self.regionChange(item, level);
            },
            regionChange: function (item, level) {
                let self = this;
                if(item.level == 1) {
                    self.thisProvince = item;
                } else if(item.level == 2) {
                    self.thisCity = item;
                }
                //
                let thisLevel = self.level;
                if(level <= thisLevel) {
                    self.getRegionsByParentId(level, item.id);
                }
            },
            getRegionsByParentId: function (level, parentId) {
                let self = this;
                let postData = {};
                postData.parentId = parentId;
                comnApi.getRegionListByParentId(postData, function (result, jqXhr) {
                    if(result.type == "info") {
                        if(level == 1) {
                            //
                            let provinces = result.data;
                            self.citys = [];
                            self.countys = [];
                            self.provinces = provinces;
                        } else if(level == 2) {
                            //
                            let citys = result.data;
                            self.countys = [];
                            self.citys = citys;

                        } else if(level == 3) {
                            //
                            self.countys = result.data;
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            notityChange: function () {
                // 发生变化时向上传递
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                //
                let selectRegionList = self.selectRegionList;
                if(selectRegionList != null && selectRegionList.length > 0) {
                    result.type = 'info';
                    result.data = selectRegionList;
                } else {
                    result.type = 'warn';
                    result.message = '请选择至少一个地区！';
                }

                return result;
            }
        }
    }

</script>




// WEBPACK FOOTER //
// src/compo/comn/RegionSelect.vue